module.exports = __webpack_public_path__ + "static/media/communication-journalism.71df33b2.svg";